import { render, staticRenderFns } from "./AddTransportationTabs.vue?vue&type=template&id=3c07f3a1&scoped=true"
import script from "./AddTransportationTabs.vue?vue&type=script&lang=ts"
export * from "./AddTransportationTabs.vue?vue&type=script&lang=ts"
import style0 from "./AddTransportationTabs.vue?vue&type=style&index=0&id=3c07f3a1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c07f3a1",
  null
  
)

export default component.exports